import {createAction, props} from '@ngrx/store';

export const saveDataSuggests = createAction('[DATA service] Save data Suggests', props<{items: []}>());